import { useContext, useEffect } from "react";
import { useAuthUser, useSignOut } from "react-auth-kit";
import { SocketContext } from "../App";
import { clearTabState } from "../utils/tabNavigation";
import { clearAuthSession } from "../hooks/userServerApi";
import useMcaNotification from "../hooks/useMcaNotification";
import useNotificationSocket from "../hooks/useNotificationSocket";

const SessionListener = () => {
  const auth = useAuthUser();
  const signOut = useSignOut();
  const socket = useContext(SocketContext);

  useMcaNotification(socket);
  useNotificationSocket(socket);

  useEffect(() => {
    const user = auth();
    const userId = user?.id || user?._id;
    if (!socket || !userId) return;

    const join = () => socket.emit("joinUserRoom", { userId: String(userId) });
    if (socket.connected) join();
    socket.on("connect", join);

    const handleSessionInvalidated = () => {
      clearTabState(userId);
      clearAuthSession();
      signOut();
      window.location.replace("/login");
    };

    socket.on("sessionInvalidated", handleSessionInvalidated);

    return () => {
      socket.off("connect", join);
      socket.off("sessionInvalidated", handleSessionInvalidated);
    };
  }, [socket, auth, signOut]);

  return null;
};

export default SessionListener;
